<template>
  <div class="bottomNavigation">

      <router-link to="/" class="rlink">
        <VsxIcon iconName="Home" :size="25" :color="$route.path == '/' ? '#FFC998' : '#fff'" type="linear" />
        <p :style="$route.path == '/' ? 'color:#FFC998' : 'color:#fff'">خانه</p>
      </router-link>


      <router-link to="/favorite" class="rlink">
        <VsxIcon iconName="HeartSearch" :size="25" :color="$route.path == '/favorite' ? '#FFC998' : '#fff'" type="linear" />
        <p :style="$route.path == '/favorite' ? 'color:#FFC998' : 'color:#fff'">علاقه مندی</p>
      </router-link>


      <router-link v-if="role == 'consultant'" to="/add" class="rlink">
        <VsxIcon iconName="Add" :size="25" :color="$route.path == '/add' ? '#FFC998' : '#fff'" type="linear" />
        <p :style="$route.path == '/add' ? 'color:#FFC998' : 'color:#fff'">افزودن</p>
      </router-link>


      <router-link to="/about" class="rlink">
        <VsxIcon iconName="Information" :size="25" :color="$route.path == '/about' ? '#FFC998' : '#fff'" type="linear" />
        <p :style="$route.path == '/about' ? 'color:#FFC998' : 'color:#fff'">درباره ما</p>
      </router-link>


    <router-link to="/profile" class="rlink">
      <VsxIcon iconName="User" :size="25" :color="$route.path == '/profile' ? '#FFC998' : '#fff'" type="linear" />
      <p :style="$route.path == '/profile' ? 'color:#FFC998' : 'color:#fff'">پروفایل</p>
    </router-link>

  </div>
</template>

<script>
export default {
  name: "bottomNavigation",
};
</script>

<style>
.rlink {
  text-decoration: none;
}

.rlink span {
  color: #263238;
}
</style>
